import React from "react";
import { Customer } from "../../../../types/inventory/CustomerTypes";
import { CustomerProfileDraft } from "../../../../types/inventory/customerRecord";
import CustomerStripeSection from "../CustomerStripeSection";
import CustomerInvoicesSection from "./CustomerInvoicesSection";

/**
 * CU-86d45b54n — customer-relevant finance only: Stripe payment information and the customer's invoices.
 * No Medicare or IHI billing, whatever the row's current account type.
 */
interface CustomerBillingTabProps {
	customer: Customer;
	draft: CustomerProfileDraft;
	onStripeCustomerIdChange?: (stripeCustomerId: string | undefined) => void;
}

const CustomerBillingTab: React.FC<CustomerBillingTabProps> = ({ customer, draft, onStripeCustomerIdChange }) => (
	<div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
		<CustomerStripeSection
			userId={customer.id}
			email={draft.email}
			name={[draft.first_name, draft.last_name].filter(Boolean).join(" ")}
			phone={draft.phone}
			stripeCustomerId={customer.stripe_customer_id}
			onStripeCustomerIdChange={onStripeCustomerIdChange}
		/>

		<CustomerInvoicesSection customer={customer} />
	</div>
);

export default CustomerBillingTab;
